//  页面参数缓存
let state = {
    nodeMap: {}, // 缓存不同根节点下当前展示的节点
    device: {}, // 设备管理
    task: {}, // 任务管理
    algorithm: {}, // 算法管理
    alarm: {}, // 告警管理
    system: {}, // 系统管理
    personal: {}, // 个人信息
    cloudTaskManager: {},//云端推理
};

//操作管理
const mutations = {
    SET_NODE_MAP(state, data = null, pNpde) {
        // console.log(data, 'data')
        if (!state.nodeMap[data?.rootPath]) {
            state.nodeMap[data?.rootPath] = {}
        }

        if (data?.childNode && !state.nodeMap[data?.rootPath][data?.childNode]) {
            // 父节点下保存对应的子节点
            state.nodeMap[data?.rootPath]['current'] = data?.childNode?.current
            state.nodeMap[data?.rootPath]['prev'] = data?.childNode?.prev
        }
    },
    CLEAR_NODE_MAP(state, data = null) {
        state.nodeMap[data?.rootPath] = {};
    },
    // 设置需要缓存的界面
    SET_CACHE(state, data = null) {
        state[data?.path] = data?.query;
    },

    // 移除缓存的界面
    REMOVE_CACHE(state, data = null) {
        
        state[data?.path] = {};
    },
};

//异步操作
const actions = {
    // 设置节点缓存
    async setNodeMap({ commit }, data = null) {
        commit("SET_NODE_MAP", data);
    },
    // 清除节点缓存
    async clearNodeMap({ commit }, data = null) {
        commit("CLEAR_NODE_MAP", data);
    },
    // 设置窗口参数
    async setQuery({ commit }, data = null) {
        commit("SET_CACHE", data);
    },

    //移除窗口参数
    async removeQuery({ commit }, data = null) {
        commit("REMOVE_CACHE", data);
    },
};

export default {
    namespaced: true, // 改为false，可以在调用时省略模块名
    state,
    mutations,
    actions,
};
